export const AUTHORITY_PROFILE_TYPE = 'authority_profile';
export const BLOG_PROFILE_TYPE = 'blog_profile';
export const INTERMEDIATE_PROFILE_TYPE = 'intermediate_profile';
export const NO_USER_PROFILE_TYPE = 'no_user_profile';
export const PRESS_PROFILE_TYPE = 'press_profile';
export const PRIVATE_PROFILE_TYPE = 'private_profile';
export const REPORTER_PROFILE_TYPE = 'reporter_profile';
export const ADMIN_PROFILE_TYPE = 'super_admin';
